'use client';

export default function GlobalError({ error, reset }) {
  const isChunkError =
    error?.message?.includes('ChunkLoadError') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module');

  if (isChunkError && typeof window !== 'undefined') {
    window.location.reload();
    return null;
  }

  return (
    <html>
      <body>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Etwas ist schiefgelaufen</h2>
          <button onClick={reset} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
            Erneut versuchen
          </button>
        </div>
      </body>
    </html>
  );
}
